import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ObjectSerializer";
import { useAuth } from "@/components/auth/Auth";
import { useWaveTopVoters } from "@/hooks/useWaveTopVoters";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { WaveLeaderboardRightSidebarVoter } from "./WaveLeaderboardRightSidebarVoter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
interface WaveLeaderboardRightSidebarVotersProps {
  readonly wave: ApiWave;
}
export const WaveLeaderboardRightSidebarVoters: React.FC<WaveLeaderboardRightSidebarVotersProps> = t0 => {
  const $ = _c(14);
  const {
    wave
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const t1 = connectedProfile?.handle ?? undefined;
  let t2;
  if ($[0] !== t1 || $[1] !== wave.id) {
    t2 = {
      waveId: wave.id,
      connectedProfileHandle: t1,
      reverse: false,
      dropId: null,
      sortDirection: "DESC",
      sort: "ABSOLUTE"
    };
    $[0] = t1;
    $[1] = wave.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    voters,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isLoading
  } = useWaveTopVoters(t2);
  let t3;
  if ($[3] !== fetchNextPage || $[4] !== hasNextPage || $[5] !== isFetchingNextPage || $[6] !== isLoading) {
    t3 = () => {
      if (hasNextPage && !isLoading && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[3] = fetchNextPage;
    $[4] = hasNextPage;
    $[5] = isFetchingNextPage;
    $[6] = isLoading;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const intersectionElementRef = useIntersectionObserver(t3);
  let t4;
  if ($[8] !== intersectionElementRef || $[9] !== isFetchingNextPage || $[10] !== isLoading || $[11] !== voters || $[12] !== wave.voting) {
    t4 = <div className="tw-space-y-2">{voters.length === 0 && !isLoading ? <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-10 tw-space-y-6 tw-text-iron-400"><div className="tw-relative tw-group"><div className="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-primary-400/20 tw-via-indigo-500/10 tw-to-iron-800/10 tw-rounded-full tw-animate-[spin_4s_linear_infinite] group-hover:tw-from-primary-400/30" /><div className="tw-absolute tw-inset-0 tw-bg-gradient-to-tr tw-from-iron-800/10 tw-via-indigo-500/10 tw-to-primary-400/20 tw-rounded-full tw-animate-[spin_5s_linear_infinite] group-hover:tw-to-primary-400/30" /><div className="tw-absolute tw-inset-0 tw-bg-gradient-radial tw-from-primary-300/5 tw-to-transparent tw-animate-pulse" /><FontAwesomeIcon icon={faClock} className="tw-size-10 tw-flex-shrink-0 tw-relative tw-text-white/60" /></div><div className="tw-flex tw-flex-col tw-items-center tw-gap-y-2"><span className="tw-tracking-tight tw-text-lg tw-font-semibold tw-bg-gradient-to-br tw-from-iron-200 tw-via-iron-300 tw-to-iron-400 tw-bg-clip-text tw-text-transparent">Be the First to Make a Vote</span><p className="tw-text-sm tw-text-iron-500 tw-text-center tw-mb-0 tw-max-w-64">Vote on drops to see voter rankings appear here.</p></div></div> : <>{voters.map((voter, index) => <WaveLeaderboardRightSidebarVoter voter={voter} key={voter.voter.id} position={index + 1} creditType={wave.voting.credit_type} />)}{isFetchingNextPage && <div className="tw-w-full tw-h-0.5 tw-bg-iron-800 tw-overflow-hidden"><div className="tw-w-full tw-h-full tw-bg-indigo-400 tw-animate-loading-bar" /></div>}<div ref={intersectionElementRef} /></>}</div>;
    $[8] = intersectionElementRef;
    $[9] = isFetchingNextPage;
    $[10] = isLoading;
    $[11] = voters;
    $[12] = wave.voting;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};